// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1cOqj","colMin":"styles_colMin__J_H2c","colCheckbox":"styles_colCheckbox__oWPrS"};